export var CardTransactionTypeEnum;
(function (CardTransactionTypeEnum) {
    CardTransactionTypeEnum["DEPOSIT"] = "DEPOSIT";
    CardTransactionTypeEnum["WITHDRAW"] = "WITHDRAW";
})(CardTransactionTypeEnum || (CardTransactionTypeEnum = {}));
//# sourceMappingURL=card-transaction-type.enum.js.map